var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("EXPIRY DATE")]),_c('h4',[_vm._v("The date the Agreement is scheduled to terminate which is one (1) year from the Effective Date.")])])
}]

export { render, staticRenderFns }